import Vue from 'vue'

const state = Vue.observable({
  /**
   * @type {{path: string, fullPath: string, title: string}[]}
   */
  pages: []
})

/**
 * @returns {{path: string, fullPath: string, title: string}[]}
 */
export function getPages() {
  return state.pages.slice()
}

/**
 * @param {import('vue-router').Route} currentRoute
 */
export function addPage(currentRoute) {
  const { title } = currentRoute.meta || {}
  if (!title) return
  const lastPage = state.pages.find(p => p.path === currentRoute.path)
  // path相同，更新fullPath数据
  if (lastPage) {
    lastPage.fullPath = currentRoute.fullPath
    return
  }
  state.pages.push({
    path: currentRoute.path,
    fullPath: currentRoute.fullPath,
    title
  })
}

/**
 * @param {{path, fullPath}} [page]
 */
export function removePage(page) {
  if (!page) {
    state.pages = []
    return
  }
  const lastIndex = state.pages.findIndex(p => p.path === page.path)
  lastIndex !== -1 && state.pages.splice(lastIndex, 1)
}



// WEBPACK FOOTER //
// ./src/store/pages.js